import { createApp } from 'vue'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import registerComponents from '@/components'
import plugins from '@/plugins'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(plugins)

// Bootstrap Analytics if configured
if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  app.use(VueGtag, {
    config: { 
      id: process.env.VUE_APP_GOOGLE_ANALYTICS,
      params: {
        send_page_view: process.env.NODE_ENV !== 'development'
      }
    }
  }, router)
}

// Register global components
registerComponents(app)

app.mount('#app')
